import React, { useEffect, useState } from 'react'
import { useBnsJiaoChengKeShiDelMutation, useBnsJiaoChengKeShiListQuery } from '../../store/ReactWebSiteApi';
import { message, Space, Table } from 'antd';
import CourseEdit from './CourseEdit';
import ModalDel from '../../cpn/ModalDel';
import Main from '../../cpn/Main';
import CourseCheck from './CourseCheck';
import TeachSelect from './TeachSelect';

function CourseTable() {
    const [info,setInfo] = useState({bjcks_bjc_id:''}); 
    const [list, setList] = useState([]); 
    const {data, isSuccess} = useBnsJiaoChengKeShiListQuery(info,{refetchOnMountOrArgChange:true});    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bjcks_id:key,bjcks_name,bjcks_ctime,bjcks_cname,bjcks_bjc_id,bjcks_xuzhi,bxmbb_id,bg_name,bjc_name} = item;
                    return item = {key,bjcks_name,bjcks_ctime,bjcks_cname,bjcks_bjc_id,bjcks_xuzhi,bxmbb_id,bg_name,bjc_name}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bjcks_ctime;
                    let bTimeString = b.bjcks_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)                
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])  
    const columns = [       
            {
                key: 'bjcks_name',
                title: '课时名称',            
                dataIndex:'bjcks_name',
                render:(_,record) => {
                    return  <CourseCheck 
                                bjcks_name={record.bjcks_name}
                                bjcks_id={record.key}
                            />
                }
            },        
            {
                key: 'bjc_name',
                title: '教程',            
                dataIndex: 'bjc_name',
                
            },
            {
                key: 'key',
                title: '编号',            
                dataIndex: 'key',
                
            },
           
            {
                key: 'time',
                title: '操作记录',
                render: (_,record) => {
                    return <>{record.bjcks_ctime + record.bjcks_cname}</>
                }
            },
            {
                key: 'action',
                title: '操作',
                render: (_, record) => {
                    return <>
                        <Space>
                            <CourseEdit
                                bjcks_id={record.key}
                                bjc_id={record.bjcks_bjc_id}
                            />            
                            <ModalDel onOk={() => {
                                del({bjcks_id:record.key}).then((res) => {
                                    console.log(res);
                                    if (res.data.Status === 'success') {
                                        message.success('删除成功！')                                                                              
                                    }
                                    if (res.data.Status === 'fail') {
                                        message.error('删除失败！'+res.data.Message)
                                    }
                                })
                            }} />  
                        </Space>
                    </>
                }
            },
        ]   
    //删除
    const [del] = useBnsJiaoChengKeShiDelMutation() 
    return (
        <Main  selectedKeys={['/CourseTable']}>           
            <div>
                <TeachSelect
                    name="teach" 
                    label='教程' 
                    wrapperCol={{span:10}} 
                    required
                    onChange={(e) => {setInfo(prevState=>({...prevState,bjcks_bjc_id:e}))}}
                    formStyle={{marginBottom:'0'}}
                    styleGoods={{width:"400px"}}
                    style={{width:"400px"}}
                />
            </div>
            <Table
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
                
            />
        </Main>
    )
    }

export default CourseTable